import { useState } from 'react';
import './WishFilterBar.css';

interface WishFilterBarProps {
  onFilterChange: (filters: {
    category?: string;
    region?: string;
    urgent?: boolean;
    search?: string;
  }) => void;
  categories: string[];
  regions: string[];
}

const WishFilterBar = ({ onFilterChange, categories, regions }: WishFilterBarProps) => {
  const [category, setCategory] = useState<string>('');
  const [region, setRegion] = useState<string>('');
  const [urgent, setUrgent] = useState<boolean>(false);
  const [search, setSearch] = useState<string>('');

  const handleCategoryChange = (value: string) => {
    setCategory(value);
    onFilterChange({
      category: value || undefined,
      region: region || undefined,
      ...(urgent ? { urgent: true } : {}),
      search: search || undefined
    });
  };

  const handleRegionChange = (value: string) => {
    setRegion(value);
    onFilterChange({
      category: category || undefined,
      region: value || undefined,
      ...(urgent ? { urgent: true } : {}),
      search: search || undefined
    });
  };

  const handleUrgentChange = (checked: boolean) => {
    setUrgent(checked);
    // Only include urgent in filters when true
    onFilterChange({
      category: category || undefined,
      region: region || undefined,
      ...(checked ? { urgent: true } : {}),
      search: search || undefined
    });
  };

  const handleSearchChange = (value: string) => {
    setSearch(value);
    onFilterChange({
      category: category || undefined,
      region: region || undefined,
      ...(urgent ? { urgent: true } : {}),
      search: value || undefined
    });
  };

  const handleReset = () => {
    setCategory('');
    setRegion('');
    setUrgent(false);
    setSearch('');
    onFilterChange({});
  };

  return (
    <div className="wish-filter-bar">
      <div className="wish-filter-bar__section">
        <h3 className="wish-filter-bar__title">篩選條件</h3>

        <div className="wish-filter-bar__filters">
          {/* Search */}
          <div className="wish-filter-bar__field">
            <label htmlFor="search" className="wish-filter-bar__label">
              關鍵字搜尋
            </label>
            <input
              type="text"
              id="search"
              className="wish-filter-bar__input"
              placeholder="搜尋許願標題或描述..."
              value={search}
              onChange={(e) => handleSearchChange(e.target.value)}
            />
          </div>

          {/* Category */}
          <div className="wish-filter-bar__field">
            <label htmlFor="category" className="wish-filter-bar__label">
              服務類別
            </label>
            <select
              id="category"
              className="wish-filter-bar__select"
              value={category}
              onChange={(e) => handleCategoryChange(e.target.value)}
            >
              <option value="">所有類別</option>
              {categories.map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
          </div>

          {/* Region */}
          <div className="wish-filter-bar__field">
            <label htmlFor="region" className="wish-filter-bar__label">
              地區
            </label>
            <select
              id="region"
              className="wish-filter-bar__select"
              value={region}
              onChange={(e) => handleRegionChange(e.target.value)}
            >
              <option value="">所有地區</option>
              {regions.map((r) => (
                <option key={r} value={r}>
                  {r}
                </option>
              ))}
            </select>
          </div>

          {/* Urgent Only */}
          <div className="wish-filter-bar__field wish-filter-bar__field--checkbox">
            <label className="wish-filter-bar__checkbox-label">
              <input
                type="checkbox"
                checked={urgent}
                onChange={(e) => handleUrgentChange(e.target.checked)}
                className="wish-filter-bar__checkbox"
              />
              <span>只顯示急件</span>
            </label>
          </div>

          {/* Reset Button */}
          <button
            className="wish-filter-bar__reset"
            onClick={handleReset}
          >
            清除篩選
          </button>
        </div>
      </div>
    </div>
  );
};

export default WishFilterBar;
